import type { FaireProductEntity } from "../../entity_types/product";

export const p_pb8vqhjfp6: FaireProductEntity = {
  token: "p_pb8vqhjfp6",
  type: "product",
  name: "Unisex Wool Socks (WL-269)",
  brandToken: "b_a990dearj1",
  brandName: "Kathmandu Imports",
  imageUrl:
    "https://cdn.faire.com/fastly/1e185f9f8a92f9b9b3327724772c493ac5e281f80413a8a7d39744f3228c1a22.jpeg",
  galleryImageUrls: [],
  priceDollars: 12.5,
  description:
    "Embrace the chill of the season with Kathmandu Imports' Wool Socks with fleece lining. These socks, made from 100% wool, are not only warm but also ideal for loungewear. Designed for a casual aesthetic, they feature a fleece lining that adds an extra layer of coziness. Suitable for both men and women, these socks are perfect for the Fall/Winter season. Plus, they're machine washable for easy care.",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:44.986Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
